import OpenAccountOfferMain from "@/components/open-account-offer/open-account-offer-main";
import SeoMetaData from "@/components/utils/seo-metadata";

import seoData from "@/data/seo/page-data.json";
import Head from "next/head";

export default function OpenAccountOffer() {
  return (
    <>
      <Head>
        <title>{seoData.OPEN_ACCOUNT_OFFER.title}</title>
        <SeoMetaData data={seoData.OPEN_ACCOUNT_OFFER} />
      </Head>

      <OpenAccountOfferMain />
    </>
  );
}
